var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "17", height: "17", viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.49854 7.04004C2.49854 6.21161 3.17011 5.54004 3.99854 5.54004H6.99854C7.82696 5.54004 8.49854 6.21161 8.49854 7.04004V14.54H2.49854V7.04004zM11.4985 10.04C11.4985 9.21161 12.1701 8.54004 12.9985 8.54004H13.9985C14.827 8.54004 15.4985 9.21161 15.4985 10.04V14.54H11.4985V10.04z", fill: "#fff", stroke: "#303030" }),
    React.createElement("path", { d: "M6.49854 3.77463C6.49854 3.02815 7.04743 2.39527 7.7864 2.28971L10.7864 1.86113C11.6901 1.73204 12.4985 2.43323 12.4985 3.34606V14.54H6.49854V3.77463Z", fill: "#fff", stroke: "#303030" }),
    React.createElement("path", { stroke: "#303030", d: "M8.499 4.04L8.499 5.04M8.499 6.04L8.499 7.04M8.499 8.04L8.499 9.04M10.498 4.04L10.498 5.04M10.498 6.04L10.498 7.04M10.498 8.04L10.498 9.04" })
  );
});